import { InjectionToken } from '@angular/core';

export const RMS_PULLDOWN_DATA = new InjectionToken<any>('RMS_PULLDOWN_DATA');
